module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Liste des personnages")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("FAMILLE ORWELL :")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Lord Caspian Orwell, mari de Lady Cynthia Orwell")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Caspian a du surnaturel en lui et est capable de magie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Cynthia fait partie du peuple Fey. Elle possède une force surhumaine et d’autres compétences.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Enfants (dans l’ordre de naissance) :")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("James, marié à Ellie (Magicienne)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("James a une force surhumaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Enfant : une fille (Prophétesse)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("James et Ellie possèdent une auberge.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Kevin, marié à Luke (moitié humain, moitié incube)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Kevin a une force surhumaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Alice, mariée à Mernon (Le Noir, célèbre assassin)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Alice a une force surhumaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Enfants : 2 filles, 2 garçons")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("May")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Brennan")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Terrian")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Broden")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Diana (Apothicaire, pratique un peu la magie)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Démétrius")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Richard (Magicien, garde de la Reine, décédé)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Médiatrice familiale")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Ophélia (Prophétesse)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Entretient une relation avec Frederick Pasley")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Médiatrice familiale")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Rebecca, mariée à Emily (moitié humaine, moitié Ondine)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Rebecca et Emily sont des escrimeuses.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Rebecca est la sœur jumelle de Pratchett.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Pratchett")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Frère jumeau de Rebecca")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Kraven")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Troisième benjamin")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Cécilia, mariée à Bérados (moitié humain, moitié Troll)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Cécilia a une force surhumaine")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Enfant : Mabel")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Sebastian (Cadet, Élu magique, Magicien élémentaire de la Terre)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("FAMILLE ROYALE :")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Le Roi Harris et la Reine Anne")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Enfant : le Prince Turren")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Cousin de Roi Harris : Lord Frederick Pasley")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Frère du Roi Harris : L’ancien Roi Alchone qui vit en exil.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Ils ont tous des pouvoirs magiques.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("GARDES ROYAUX :")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Le Capitaine Pembrost")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Le Lieutenant Adams")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Le Sergent Hooper")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Le Sergent Vendrix")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Le Sergent Bradley")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Le Sergent Thimbly")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Sonny")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("DIFFÉRENTS MAGICIENS :")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Margaret")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Lord Harold Bast")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Trey Ausher (également aubergiste)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("CLIENTS DE LA LIBRAIRIE D’HAROLD :")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Mr Jenkins")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Mme Crane")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("RIVAUX")]), _vm._v("—Tous formés à la magie, avec Lord Orwell, par Maître Uvel")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Trenton Keyes")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Dalia")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Féroas")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("NOTABLES DE LARNLYON :")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Earl Grenwish")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Lord Ulani")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Lord Piadas : Ambassadeur d’Anerith, présent en ce moment à Larnlyon à cause du vol de l’amulette.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("PAYS :")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Larnlyon:")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Gouverné par le Roi Harris et la Reine Anne.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Capitale : Trellium")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("AUTRES VILLES :")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Cern—Abrite la Rangée des Magiciens, où vivent James, Ellie et Lord Trey Ausher.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Bruwen—Où vivent Kevin, Luke, Margaret, et Harold")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Anerith")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Ancien roi : Le Roi Orsen")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Jesaro:")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Pays anarchique où réside la Confrérie des Assassins.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Territoires Saints :")]), _vm._v(" "), _c('p', {
    staticClass: "P_Glossary"
  }, [_vm._v("Pays où toute magie est bannie.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0